import { orderBy } from 'lodash-es'

// NOTE an event belongs to a month when one of its ranges starts in, ends in, or spans it
export const eventsGetItemsForMonth = (months: array = [], eventsData: array = []) => {
  return months?.map(month => {
    const monthIndex = eventsStringToMonthIndex(month)
    const eventItems = eventsData?.filter(entry => {
      return eventsGetMonthSpans(entry).some(({ start, end }) => start <= monthIndex && monthIndex <= end)
    })
    const eventItemsSorted = orderBy(eventItems, ['sortKeyAsc', 'sortKeyDesc', 'title'], ['desc', 'asc', 'asc'])

    const monthName = dayJs(month)?.format('MMMM')
    return {
      startOfMonth: month,
      monthName: monthName,
      eventItems: eventItemsSorted
    }
  })
}
